import PropTypes from 'prop-types';

export default function OutlineArrowBottom(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="m15.25 11.25-5 5-5-5"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
            <path d="M9.5 3.75a.75.75 0 0 1 1.5 0H9.5Zm.75 12H9.5v-12H11v12h-.75Z" fill={color} />
        </svg>
    );
}

OutlineArrowBottom.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
